<div class="document-body">
    <section class="margin-bottom-10">
        <label class="title-table-style">
            {{ 'cf-signature-anonymous.label.title' | translate }}
        </label>
    </section>
    <section style="height: 100%">
        <div *ngIf="isDocumentLoaded">
            <section>
                <clfl-document-info-section [document]="document"></clfl-document-info-section>
                <form class="k-form" #form="ngForm" (ngSubmit)="save()">
                    <kendo-gridlayout [cols]="['100%']" [gap]="10">
                        <kendo-gridlayout-item [col]="1" [row]="1">
                            <kendo-formfield>
                                <kendo-label>{{ 'cf-signature.dialog.signWithPin.column.pin' | translate }}:</kendo-label>
                                <input name="pin" kendoTextBox type="text" #pin="ngModel" [(ngModel)]="pinCode" required pattern="\d{4}" />
                                <kendo-formerror *ngIf="pin.errors?.['required']" textContent="{{ 'input.required.error' | translate }}">
                                </kendo-formerror>
                                <kendo-formerror
                                    *ngIf="pin.errors?.['pattern']"
                                    textContent="{{ 'cf-signature.dialog.signWithPinPatternRequired' | translate }}">
                                </kendo-formerror>
                            </kendo-formfield>
                        </kendo-gridlayout-item>
                        <kendo-gridlayout-item [col]="1" [row]="2">
                            <button kendoButton type="submit" themeColor="success" style="width: 100%">
                                <i class="fas fa-save"></i>
                                {{ 'labels.sign' | translate }}
                            </button>
                        </kendo-gridlayout-item>
                    </kendo-gridlayout>
                </form>
            </section>
        </div>
    </section>
</div>

<div class="loader" *ngIf="isLoading">
    <div class="grid-loading-container">
        <kendo-loader type="converging-spinner" themeColor="info" size="medium"> </kendo-loader>
    </div>
</div>
